import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { routes } from './router';

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <ThemeProvider>
          <LanguageProvider>
            <NotificationProvider>
              <Routes>
                {routes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </NotificationProvider>
          </LanguageProvider>
        </ThemeProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
